import { GET_USERS_QUERY } from "@/apis/gql/apolloClient";
import { useSession } from "@/lib/auth/auth";
import type {
  CompanyUserRole,
  User,
  UserAccountingFirm,
  UserWithAccountingFirms,
  UserWithAccountingFirmsAndCompanyRoles,
} from "@/types/user";
import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import type { UserQueryData } from "./types";

type GetUsersQueryData = {
  usersInSameAccountingFirm: UserQueryData[];
};

export function useUsers(
  skip: boolean,
  withoutCurrentUser = false,
  withCompanyUsers = false,
) {
  const [users, setUsers] = useState<
    (User & {
      companies: CompanyUserRole[];
    })[]
  >([]);

  const [loading, setLoading] = useState(false);

  const { data: session } = useSession();
  const currentUser = session?.user;

  const { data, loading: queryLoading } = useQuery<GetUsersQueryData>(
    GET_USERS_QUERY,
    {
      skip,
      variables: { withCompanyUsers },
    },
  );

  const filteredUsers = withoutCurrentUser
    ? data?.usersInSameAccountingFirm.filter(
        (user) => user.email !== currentUser?.email,
      )
    : data?.usersInSameAccountingFirm;

  useEffect(() => {
    if (filteredUsers) {
      const filteredUsersWithAccountingFirms = filteredUsers.map((user) => ({
        ...user,
      }));
      setUsers(filteredUsersWithAccountingFirms);
    }
  }, [filteredUsers]);

  useEffect(() => {
    setLoading(queryLoading);
  }, [queryLoading]);

  return {
    users: users,
    loading,
  };
}
